import { getDefaultCdnBaseUrl } from "@tldraw/editor";
import { useMemo } from "react";
let defaultEditorAssetUrls = {
  fonts: {
    draw: 'https://padlet.net/fonts/shantell-sans/Shantell_Sans-Normal-Medium.woff2', // Shantell Sans
    monospace: 'https://padlet.net/fonts/courierprime/courier_prime_bold-webfont.woff2', // Courier Prime
    sansSerif: 'https://padlet.net/fonts/inter/3.19/Inter-SemiBold.woff2', // Inter
    serif: 'https://padlet.net/fonts/lora/3.006/Lora-SemiBold.woff2', // Lora
  }
};
function setDefaultEditorAssetUrls(assetUrls) {
  defaultEditorAssetUrls = assetUrls;
}
function useDefaultEditorAssetsWithOverrides(overrides) {
  return useMemo(() => {
    if (!overrides) return defaultEditorAssetUrls;
    return {
      fonts: { ...defaultEditorAssetUrls.fonts, ...overrides?.fonts }
    };
  }, [overrides]);
}
export {
  defaultEditorAssetUrls,
  setDefaultEditorAssetUrls,
  useDefaultEditorAssetsWithOverrides
};
//# sourceMappingURL=assetUrls.mjs.map
